export default "__VITE_ASSET__CeJ_p2sT__"